export default __webpack_public_path__ + "static/2-secrets-1d9ca964bb8ee85851be34807a8157a2.png";